export enum ReportTemplateFieldStyle {
  None = 0,
  Bold = 1,
  All = -1,
}
